import { M as MapyReviewBadgeNew$1, d as defineCustomElement$1 } from './mapy-review-badge-new2.js';

const MapyReviewBadgeNew = MapyReviewBadgeNew$1;
const defineCustomElement = defineCustomElement$1;

export { MapyReviewBadgeNew, defineCustomElement };

//# sourceMappingURL=mapy-review-badge-new.js.map